<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex; margin-top: 100px"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="video_setting" v-show="!loading">
        <div class="video_setting" v-if="VideoUrl">
          <video
            autoplay
            controls
            controlsList="nodownload"
            id="myVideo"
            @play="getProgress"
            @loadeddata="onPaused"
            @pause="onPaused"
            ref="videoRef"
          >
            <source :src="VideoUrl" type="video/mp4" />
          </video>
        </div>
        <div class="position">
          <CButton
            color="info"
            size="lg"
            :disabled="disable"
            @click="nextRoute"
          >
            {{ `${disable ? progressTime : 'Next'}` }}
          </CButton>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  components: {LoadingMDL},
  name: 'VAT01',
  props: {},
  data() {
    return {
      VideoUrl: '',
      disable: null,
      play: false,
      loading: true,
      showVideo: false,
      duration: null,
      progressTime: 0,
      language: '',
      time: null,
      navigation: null,
      condition: [],
      startTime: '',
      criteria_id: '',
      topic: {},
      //code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      v3Data: null,
      nextPath: null,
    };
  },
  methods: {
    onPaused: function (val) {
      if (this.duration != 0 && val.target.currentTime == val.target.duration) {
        this.$refs.videoRef.play();
      }
      clearInterval(this.time);
    },
    getProgress: function (val) {
      if (val.target.duration != null) {
        if (this.duration == null) {
          this.duration = parseInt(val.target.duration);
        }
        if (this.disable) {
          this.time = setInterval(() => {
            this.duration = this.duration - 1;
            if (this.duration == 0) {
              this.disable = false;
              clearInterval(this.time);
            }
            const minute = this.duration / 60;
            const secon = (this.duration % 60) / 10;
            this.progressTime = `${Math.trunc(minute)}:${
              Number.isInteger(secon)
                ? `${secon}0`
                : secon.toString().replace('.', '')
            }`;
          }, 1000);
        }
      }
    },
    commitUserProgress: function () {
      const path = this.navigation;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          console.log(this.v3Data, ' v3');

          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
    nextRoute: function () {
      this.commitUserProgress();
    },
    async onLoadData() {
      this.loading = true;
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];
      this.language = this.$store.getters['language/getLanguage'];

      await this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      const template = val.templates[0];
      this.v3Data = val;

      const vidItem = template?.content?.item?.[0];

      this.VideoUrl = 'https://mdl.mfu.ac.th' + vidItem.data;

      this.navigation = template.navigate.next.action;

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'VAT01 Navigate');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.position {
  display: flex;
  position: absolute;
  right: 8%;
  top: 10%;
}
video::-internal-media-controls-download-button {
  display: none;
}
.button_setting {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  padding: 0px 1px 0px 1px;
  background-color: #89abe6;
  width: 120px;
  height: 60px;
  color: white;
  border-radius: 7px !important;
  cursor: pointer;
}
.video_setting {
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}

#myVideo {
  margin-top: 2.5%;
  right: 0;
  bottom: 0;
  width: 90%;
  height: 90%;
}
.video_setting {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-info {
  width: 150px;
  height: 60px;
  font-size: 25px;
}

/* @media only screen and (max-width: 600px) {
  #myVideo {
    width: 100%;
    height: 250px !important;
  }
} */
@media only screen and (max-width: 600px) {
  #myVideo {
    width: 100%;
    height: 250px !important;
  }
  .video_setting {
    padding-top: 30%;
    padding-bottom: 20%;
  }
  .btn-info {
    width: auto;
    height: auto;
    font-size: 20px;
  }
  .position {
    top: 40%;
  }
}
@media only screen and (min-width: 667px) and (max-width: 812px) {
  .position {
    right: 8%;
    top: 8%;
  }
  .video_setting {
    padding-top: 3%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1025px) and (orientation: portrait) {
  .position {
    right: 8%;
    top: 10%;
  }
  .video_setting {
    padding-top: 1%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1025px) and (min-height: 1365px) and (max-height: 1366px) {
  .position {
    right: 8%;
    top: 8%;
  }
  .video_setting {
    padding-top: 1%;
  }
}
@media only screen and (min-width: 1026px) and (max-width: 1366px) {
  .position {
    right: 8%;
    top: 10%;
  }
}
</style>
